import React from 'react';
import { TextareaField } from '@wk/components-react16';
import { useValidatedField } from '../../formHooks';
import { ValidatedFieldAtoms } from '../../formAtoms';

interface TextareaInputFieldProps {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldAtoms: ValidatedFieldAtoms<any, any>;
  helperText?: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
}

export const TextareaInputField: React.FC<TextareaInputFieldProps> = ({
  disabled = false,
  fieldAtoms,
  helperText,
  label,
  placeholder,
  required = false,
  rows = 4,
}) => {
  const { error, handleBlur, handleChange, showError, value } =
    useValidatedField(fieldAtoms);

  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    handleChange(event.target.value);
  };

  return (
    <div>
      <TextareaField label={label} size="small">
        <textarea
          disabled={disabled}
          onBlur={handleBlur}
          onChange={handleTextareaChange}
          placeholder={placeholder}
          rows={rows}
          value={value || ''}
          required={required}
        />
      </TextareaField>
      {showError && error && (
        <div
          style={{
            color: 'var(--color-error, #d32f2f)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
      {!showError && helperText && (
        <div
          style={{
            color: 'var(--color-text-secondary, #666)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};
